import React from 'react'
import suitSymbol from '../../../utils/Deck/suitSymbol'
import './TrumpLabel.css'

type TrumpLabelProps = {
    suit?: string
    lang: string
}

export class TrumpLabel extends React.Component<TrumpLabelProps, {}> {
    render(): JSX.Element {
        let {suit, lang} = this.props
        let symbol = suitSymbol(String(suit), true)

        return (
            <div className="TrumpLabel" data-symbol={symbol}>
                {lang === 'ru' ? 'Козырная масть' : 'Trump suit'}
            </div>
        )
    }
}
